module.exports = __webpack_public_path__ + "img/end-icon.0b5a0b9a.png";